<template>
    <az-formbar>
        <div :class="inserindo?'hide':'show'">
            <div class="itens">
                <div class="item">
                    <label>Número do Processo</label>
                    <span>{{licitacao.numProcesso}}</span>
                    <br>
                    <span v-if="licitacao.numRepeticao > 0">
                      <strong>Repetição: </strong>{{licitacao.numRepeticao}}
                    </span>
                </div>
                <div class="item" v-if="!ocorrencia">
                    <label>Situação</label>
                    <span v-if="licitacao.publicado && licitacao.executarLicitacao">{{licitacao.status | statusLicitacao}}</span>
                    <span v-else-if="licitacao.publicado && !licitacao.executarLicitacao">Publicado</span>
                    <span v-else>Em elaboração</span>
                </div>
                <div class="item">
                    <label>Número do Edital</label>
                    <span>{{licitacao.numeroEdital}}</span>
                </div>
              <div class="item" v-if="licitacao.modoDisputa === 'ABERTO_FECHADO' && !ocorrencia">
                <label>Tempo da Fase Aberto/Fechado</label>
                <span>{{licitacao.tempoFaseAbertoFechado}} min.</span>
              </div>
                <div class="item" v-if="licitacao.justificativa && !ocorrencia">
                    <label>Justificativa</label>
                    <span>{{licitacao.justificativa}}</span>
                </div>
            </div>
            <div class="actions" v-if="editando">
              <v-menu v-if="podeAcessarProcessoVirtual" offset-y content-class="pd-menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="processo-digital-btn" color="secondary" dark>
                    PROCESSO DIGITAL
                    <v-icon right>arrow_drop_down</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-tile v-if="podeAcessarProcessoVirtual" @click="acessarProcessoDigital">
                    <v-list-tile-content>
                      <v-list-tile-title class="pd-item">Acessar</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile v-if="podeAcessarProcessoVirtual && ehIntegracaoEdocsAtiva" @click="acessarEdocs">
                    <v-list-tile-content>
                      <v-list-tile-title class="pd-item">Enviar E-Docs</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile v-if="podeAcessarDocumentosVirtualizados" @click="acessarDocumentos">
                    <v-list-tile-content>
                      <v-list-tile-title class="pd-item">Documentos</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>

                <licitacao-atualizacao-enviar-mais-brasil v-if="licitacao.recursoFederal && licitacao.id != null"/>
                <licitacao-atualizacao-acoes-refazer v-if="exibirAcaoRefazer(licitacao)"/>
                <licitacao-atualizacao-acoes-publicar v-if="!licitacao.publicado"/>
                <licitacao-atualizacao-acoes-area-publica v-if="licitacao.publicado"/>
                <licitacao-atualizacao-acoes-acessar v-if="licitacao.executarLicitacao && licitacao.publicado"/>
                <div class="actions">
                    <v-menu offset-y left>
                        <v-btn slot="activator" dark icon>
                            <v-icon>more_vert</v-icon>
                        </v-btn>
                        <v-list>
                          <licitacao-atualizacao-acoes-alterar-dados v-if="estaNaAbaDadosGerais"/>
                          <licitacao-atualizacao-acoes-suspender v-if="licitacao.publicado && licitacao.status !== 'SUSPENSO'"/>
                          <licitacao-atualizacao-acoes-excluir :licitacaoPublicada="licitacao.publicado" v-if="exibirAcaoExcluir(licitacao)"/>
                          <licitacao-atualizacao-acoes-imprimir-historico-mais-brasil v-if="licitacao.recursoFederal && licitacao.id != null"/>
                          <licitacao-atualizacao-acoes-despublicar v-if="licitacao.publicado && licitacao.status === 'AGUARDANDO_ABERTURA' && licitacao.permiteDespublicar"/>
                            <licitacao-atualizacao-acoes-remessa v-if="licitacao.numProcesso && licitacao.numeroEdital && ehIntegracaoPrestacaoContasAtiva"
                                :num-processo="licitacao.numProcesso" :numero-edital="licitacao.numeroEdital" ref="submenuRemessa"
                            />
                            <licitacao-atualizacao-acoes-ocorrencias v-if="licitacao.id && licitacao.publicado && ehIntegracaoPrestacaoContasAtiva" :licitacao-id="licitacao.id" ref="submenuRemessa" />
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </div>
    </az-formbar>
</template>

<script>
    import {mapState} from 'vuex'
    import LicitacaoAtualizacaoAcoesExcluir from './LicitacaoAtualizacaoAcoesExcluir';
    import LicitacaoAtualizacaoAcoesPublicar from './LicitacaoAtualizacaoAcoesPublicar';
    import LicitacaoAtualizacaoAcoesAcessar from './LicitacaoAtualizacaoAcoesAcessar';
    import LicitacaoAtualizacaoAcoesAreaPublica from './LicitacaoAtualizacaoAcoesAreaPublica';
    import LicitacaoAtualizacaoAcoesRefazer from './LicitacaoAtualizacaoAcoesRefazer';
    import LicitacaoAtualizacaoEnviarMaisBrasil from './LicitacaoAtualizacaoEnviarMaisBrasil';
    import LicitacaoAtualizacaoAcoesImprimirHistoricoMaisBrasil from './LicitacaoAtualizacaoAcoesImprimirHistoricoMaisBrasil';
    import LicitacaoAtualizacaoAcoesDespublicar from '@/views/licitacao/detalhe/orgao/acoes/LicitacaoAtualizacaoAcoesDespublicar';
    import LicitacaoAtualizacaoAcoesDocumentos from "@/views/licitacao/detalhe/orgao/acoes/LicitacaoAtualizacaoAcoesDocumentos";
    import LicitacaoAtualizacaoAcoesProcessoDigital from "@/views/licitacao/detalhe/orgao/acoes/LicitacaoAtualizacaoAcoesProcessoDigital";
    import LicitacaoAtualizacaoAcoesRemessa from "@/views/licitacao/detalhe/orgao/acoes/LicitacaoAtualizacaoAcoesRemessa.vue";
    import LicitacaoAtualizacaoAcoesOcorrencias from "@/views/licitacao/detalhe/orgao/acoes/LicitacaoAtualizacaoAcoesOcorrencias.vue";
    import LicitacaoAtualizacaoAcoesEdocs from "@/views/licitacao/detalhe/orgao/acoes/LicitacaoAtualizacaoAcoesEdocs.vue";
    import LicitacaoAtualizacaoAcoesSuspender from "@/views/licitacao/detalhe/orgao/acoes/LicitacaoAtualizacaoAcoesSuspender.vue";
    import router from "@/router";
    import { mapMutations } from 'vuex'
    import { mutationTypes} from '@/commons/constants'
    import LicitacaoAtualizacaoAcoesAlterarDados
      from "@/views/licitacao/detalhe/orgao/acoes/LicitacaoAtualizacaoAcoesAlterarDados.vue";

    export default {
        name: 'LicitacaoAtualizacaoAcoes',
        components: {
          LicitacaoAtualizacaoAcoesAlterarDados,
            LicitacaoAtualizacaoAcoesProcessoDigital,
            LicitacaoAtualizacaoEnviarMaisBrasil,
            LicitacaoAtualizacaoAcoesAcessar,
            LicitacaoAtualizacaoAcoesAreaPublica,
            LicitacaoAtualizacaoAcoesPublicar,
            LicitacaoAtualizacaoAcoesExcluir,
            LicitacaoAtualizacaoAcoesRefazer,
            LicitacaoAtualizacaoAcoesImprimirHistoricoMaisBrasil,
            LicitacaoAtualizacaoAcoesDespublicar,
            LicitacaoAtualizacaoAcoesDocumentos,
            LicitacaoAtualizacaoAcoesRemessa,
            LicitacaoAtualizacaoAcoesOcorrencias,
            LicitacaoAtualizacaoAcoesEdocs,
            LicitacaoAtualizacaoAcoesSuspender
        },
        props: {
            inserindo: {
                type: Boolean,
                default: false
            },
            ocorrencia: {
              type: Boolean,
              default: false
            }
        },
        computed: {
            editando() {
                return this.$route.query.edicao
            },
            ehVirtualizacaoAtiva(){
              return this.parametros.propriedadesLicitacao.integration.virtualizacao.ativo
            },
            possuiLoteComResultado(){
              return this.licitacao.possuiLoteComResultado
            },
            ehLicitacaoVirtualizada(){
              return !!this.licitacao.processoVirtualUrl
            },
            podeAcessarProcessoVirtual(){
              return this.ehVirtualizacaoAtiva && this.ehLicitacaoVirtualizada
            },
            podeAcessarDocumentosVirtualizados(){
              return this.ehVirtualizacaoAtiva && this.ehLicitacaoVirtualizada
            },
            ehIntegracaoPrestacaoContasAtiva(){
              return this.parametros.propriedadesLicitacao.integration.integracaoSistemaDePrestacaoContasAtiva
            },
            ehIntegracaoEdocsAtiva() {
              return this.parametros.propriedadesLicitacao.integration.integracaoSistemaEdocsAtiva
            },
            estaNaAbaDadosGerais() {
              return this.$route.name === 'licitacaoAtualizacaoDadosGerais'
            },
            ...mapState(['licitacao', 'parametros'])
        },
        methods:{
          ...mapMutations([
            mutationTypes.MOSTRAR_MENSAGEM_WARNING
          ]),
          exibirAcaoExcluir(licitacao){
            if(!licitacao.usuarioComissao){
              return false
            }
            if(licitacao.origem === 'EXTERNA'){
              return this.licitacao.status !== 'ENCERRADO' && !this.licitacao.reaberto
            }
            return !licitacao.publicado
          },
          exibirAcaoRefazer(licitacao) {
            return licitacao.status === 'ENCERRADO' && licitacao.origemExecucao !== 'PREPARACAO' && licitacao.usuarioComissao
          },
          acessarEdocs(){
            router.push({name: 'edocs', params: {id: this.licitacao.id}})
          },
          acessarDocumentos(){
            router.push({name: 'documentosVirtualizacao', params: {id: this.licitacao.id}})
          },
          acessarProcessoDigital(){
            if (this.licitacao.processoVirtual && this.licitacao.processoVirtualUrl ==='nao_sincronizado_edocs') {
              this.mostrarNotificacaoWarning('Não é possível acessar o processo no e-Docs pois ainda não foi enviado nenhum documento')
              return
            }

            const url = this.licitacao.processoVirtualUrl
            if (url) {
              window.open(url, '_blank').focus();
            }
          }
        }
    }
</script>

<style scoped>

    .item label {
        font-weight: bold;
    }

    .az-form-bar .show {
        height: auto !important;
    }

    .pd-menu {
        min-width: 200px;
        padding: 0;
    }

    .pd-menu .v-list-item {
        padding: 0;
    }

    .pd-menu .pd-item {
        display: block;
        white-space: nowrap;
        font-weight: 500;
        cursor: pointer;
    }

    .pd-menu .pd-item:hover {
        background-color: #f5f5f5;
    }

</style>
